const typeHoliday = {
    national: 'national',
    state: 'state',
    municipal: 'municipal',
    custom: 'custom',
};

export default typeHoliday;
